import { Component, OnInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-price-breakup-group',
  templateUrl: './price-breakup-group.component.html',
  styleUrls: ['./price-breakup-group.component.css']
})
export class PriceBreakupGroupComponent implements OnInit {

  currOrganization: any;
  loggedInUser: any;
  groupData: any;
  isAdminHotel: any = false;

  constructor(
    private activeModal: NgbActiveModal
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }
  }

  @Input() data: any;
  @Input() bookingData: any;
  @Input() isCorporate: any;

  ngOnInit(): void {
    this.processBreadCrumbLinks();
  }

  private processBreadCrumbLinks() {
    console.log('data!!! ', this.data, this.bookingData);
    this.groupData = this.bookingData;
    if(this.bookingData && this.bookingData.confirmedCorpId && this.bookingData.confirmedCorpId == 'aTMs0GGvmoONQ7vzzHik') {
      this.isAdminHotel = true;
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
